module.exports = __webpack_public_path__ + "img/words-logo.84c6cb6c.png";